import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ListRoleScreenYGPermissionRolesSlice = createSlice({
    name: "ListRoleScreenYGPermissionRoles",
    initialState: {} as IReduxState<any>,
    reducers: {
        getListRoleScreenYGPermissionRoles: (state) => {
            state.isLoading = true;
        },
        successListRoleScreenYGPermissionRoles: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureListRoleScreenYGPermissionRoles: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        clearListRoleScreenYGPermissionRoles: (state) => {
            state.data = undefined;
        }
    },
});

export const {
    getListRoleScreenYGPermissionRoles,
    successListRoleScreenYGPermissionRoles,
    failureListRoleScreenYGPermissionRoles,
    clearListRoleScreenYGPermissionRoles
} = ListRoleScreenYGPermissionRolesSlice.actions;

export default ListRoleScreenYGPermissionRolesSlice.reducer;
